import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { paymentsAPI } from '../../lib/api';

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const response = await paymentsAPI.getAll();
      setPayments(response.data);
    } catch (error) {
      console.error('Error fetching payments:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const columns = [
    { key: 'reference_type', label: 'Type' },
    { key: 'amount', label: 'Amount', type: 'currency' },
    { key: 'payment_method', label: 'Method' },
    { key: 'payment_date', label: 'Date', type: 'date' },
    { key: 'notes', label: 'Notes' },
  ];

  const formFields = [
    {
      name: 'reference_type',
      label: 'Payment Type',
      type: 'select',
      required: true,
      options: [
        { value: 'invoice', label: 'Invoice Payment' },
        { value: 'bill', label: 'Bill Payment' },
      ],
    },
    { name: 'reference_id', label: 'Reference ID', required: true, placeholder: 'Invoice/Bill ID' },
    { name: 'amount', label: 'Amount', type: 'number', required: true, defaultValue: 0 },
    {
      name: 'payment_method',
      label: 'Payment Method',
      type: 'select',
      defaultValue: 'bank_transfer',
      options: [
        { value: 'cash', label: 'Cash' },
        { value: 'bank_transfer', label: 'Bank Transfer' },
        { value: 'credit_card', label: 'Credit Card' },
        { value: 'check', label: 'Check' },
      ],
    },
    { name: 'payment_date', label: 'Payment Date', type: 'date' },
    { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Additional notes' },
  ];

  const handleAdd = async (data) => {
    await paymentsAPI.create(data);
    fetchPayments();
  };

  const handleEdit = async (id, data) => {
    await paymentsAPI.update(id, data);
    fetchPayments();
  };

  const handleDelete = async (id) => {
    await paymentsAPI.delete(id);
    fetchPayments();
  };

  return (
    <DataTable
      title="Payments"
      description="Track all payments"
      data={payments}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
      searchField="reference_type"
    />
  );
};

export default Payments;
